
export const environment = {
  production: false,
  token_label: '__@lr_authadmin',
  api_url:"https://registry.lernerandroweapp.com/api/",
  // api_url:"http://localhost:3001/api/",
};
